function isObject(item: any): boolean {
  return item && typeof item === "object" && !Array.isArray(item);
}

function mergeDeep(target: any, source: any): any {
  const output = Object.assign({}, target);

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }

  return output;
}

function getCookieValueByName(name: string): string {
  const cookies = document.cookie.split("; ");
  const cookie = cookies.find((cookie) => cookie.startsWith(name));

  if (cookie) {
    return cookie.split("=")[1];
  }

  return "";
}

export { mergeDeep, isObject, getCookieValueByName };
